import PropTypes from "prop-types";
import { companyName, version } from "../../version";

function Footer({ default: isDefault }) {
  return (
    <footer
      className={`w-full ${
        isDefault ? "bg-white shadow-md" : "bg-gray-900"
      } text-gray-400`}
    >
      <div className="text-muted text-sm max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between">

        {/* Copyright */}
        <p className="text-sm text-center md:text-right m-0">
          &copy; {1900 + new Date().getYear()} {companyName}
        </p>
        <p className="text-sm text-center md:text-right m-0">
           v {version}
        </p>
      </div>
    </footer>
  );
}

Footer.defaultProps = {
  default: false,
  fluid: false,
};

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
